const save = ({key, value}) => {
  window.localStorage.setItem(key, value);
};

const deleteAction = ({key}) => {
  window.localStorage.removeItem(key);
};

const get = ({key}) => {
  return window.localStorage.getItem(key);
};

export const LocalStorageService = {
  get,
  save,
  delete: deleteAction
};
